module.exports = __webpack_public_path__ + "static/media/Pista_Botao.f5e3b3a6.png";